import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import PublicApp from './components/public/PublicApp/PublicApp';

ReactDOM.render(
  <React.StrictMode>
    <PublicApp />
  </React.StrictMode>,
  document.getElementById('react-root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
